import React, { useContext, useEffect, useState } from "react"
import { TrashIcon, CollectionIcon, PencilIcon } from "@heroicons/react/outline"
import { EndpointConfig } from "../../config"
import { AuthContext } from "../../context/auth.context"
import { axiosInstance } from "../../lib/axios"
import { toast } from "react-toastify"
import Button from "../atoms/button.atom"
import Modal from "../atoms/modal.atom"
import { Header } from "../common/header"
import Loader from "../loader/loader.component"
import { getCookie } from "../../helper/auth"

export const AllCampaign = ({ hubId, onAddConfig, onUpdateConfig }) => {
	const { auth, setAuth } = useContext(AuthContext)
	const [configs, setConfigs] = React.useState([])
	const [loading, setLoading] = React.useState(false)
	const [isModalVisible, setIsModalVisible] = React.useState(false)
	const [configId, setConfigId] = React.useState()

	const getConfigs = () => {
		setLoading(true)
		;(async () => {
			const token = getCookie("token")
			const res = await axiosInstance.get(EndpointConfig.Campaign, {
				headers: {
					Authorization: `Bearer ${token}`
				}
			})
			setConfigs(res.data.data || [])
		})()
			.catch(console.err)
			.finally(() => setLoading(false))
	}

	React.useEffect(() => {
		getConfigs()
	}, [])

	const deleteConfig = () => {
		setIsModalVisible(false)
		setLoading(true)
		;(async () => {
			const token = getCookie("token")
			const res = await axiosInstance.delete(EndpointConfig.Campaign, {
				headers: { Authorization: `Bearer ${token}` },
				data: { configId }
			})
			toast("Deleted Successfully")
			getConfigs()
		})()
			.catch(console.err)
			.finally(() => setLoading(false))
	}

	const editConfig = ({ configId }) => {
		setLoading(true)
		;(async () => {
			const token = getCookie("token")
			const res = await axiosInstance.get(EndpointConfig.Campaign, {
				headers: { Authorization: `Bearer ${token}` },
				data: { configId }
			})
			const selectedConfigData = res.data.data.find((c) => c._id === configId)

			setAuth({ hubId: hubId, passData: selectedConfigData })
			onUpdateConfig()
		})()
			.catch(console.err)
			.finally(() => setLoading(false))
	}

	return (
		<>
			<Modal
				children={
					<div className="flex font-sans">
						<form className="flex-auto p-6">
							<div className="flex flex-wrap">
								<h1 className="flex-auto text-lg font-semibold text-slate-900">
									Delete
								</h1>
								<div className="flex-none w-full mt-2 text-sm font-normal text-slate-700">
									Are you sure you want to delete this Campaign? Click Yes to
									Proceed.!
								</div>
							</div>
							<div className="flex my-5 mb-1 space-x-4 text-sm font-medium">
								<div className="flex items-end justify-end flex-auto space-x-4">
									<button
										className="h-10 px-6 font-semibold text-white bg-blue-700 rounded-md"
										type="submit"
										onClick={() => deleteConfig()}
									>
										Yes
									</button>
									<button
										className="h-10 px-6 font-semibold border rounded-md border-slate-500 text-slate-900"
										type="button"
										onClick={() => setIsModalVisible(false)}
									>
										No
									</button>
								</div>
							</div>
						</form>
					</div>
				}
				toggle={() => setIsModalVisible(false)}
				open={isModalVisible}
			/>
			<div className="flex flex-col">
				<Header
					IconName={CollectionIcon}
					subText={"List"}
					mainText={"Campaign Configurations"}
					postComponent={
						<Button className="w-full" onClick={onAddConfig}>
							Add Campaign
						</Button>
					}
				/>

				{loading ? (
					<Loader />
				) : (
					<>
						<div className="flex flex-col pb-4 overflow-x-auto bg-white rounded">
							<div className="inline-block min-w-full py-2">
								<table className="common">
									<thead className="">
										<tr className="">
											{/* <th className="">Config ID</th> */}
											<th className="">Record Name</th>
											<th className="">Status</th>
											<th className="">Scheduled On</th>
											<th className="">Excuted Status</th>
											<th className="">Actions</th>
										</tr>
									</thead>
									<tbody>
										{configs.map((config) => (
											<tr key={config._id}>
												{/* <td className="">{config._id} </td> */}
												<td className="font-medium">{config.name}</td>
												<td className="">{config.status}</td>
												<td className="">{config.scheduledOn}</td>
												<td className="">{config.excutedStatus}</td>
												<td className="">
													<div className="flex flex-row gap-2">
														<TrashIcon
															className="w-4 h-4 text-red-500 cursor-pointer"
															onClick={() => {
																setConfigId(config._id)
																setIsModalVisible(true)
															}}
														/>
														<PencilIcon
															className="w-4 h-4 text-blue-500 cursor-pointer"
															onClick={() =>
																editConfig({ configId: config._id })
															}
														/>
													</div>
												</td>
											</tr>
										))}
									</tbody>
								</table>
							</div>
						</div>
					</>
				)}
			</div>
		</>
	)
}
